import api from "./api.js";

export default class ProductApi {
  static async createProduct(data) {
    return await api.post(`api/merch`, data);
  }

  static async uploadProduct(productId) {
    return await api.post(`api/merch/${productId}`);
  }

  static async getListProduct(params) {
    return await api.get(`api/merch`, params);
  }

  static async getByIdProduct(productId, params) {
    return await api.get(`api/merch/${productId}`, params);
  }

  static async updateProduct(productId, data) {
    return await api.patch(`api/merch/${productId}`, data);
  }

  static async updateActivationProduct(productId, data) {
    return await api.patch(`api/merch/activation/${productId}`, data);
  }

  static async deleteProduct(productId, params) {
    return await api.del(`api/merch/${productId}`, params);
  }

  static async updateOrderProduct(productId, data) {
    return await api.patch(`api/merch/order/${productId}`, data);
  }
}
